import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Kicker, Section } from "@/components/landing/kit";
import { FAQS } from "@/lib/site-data";

const Faq = () => (
  <Section id="faq" className="border-y border-[#E5E8F0] bg-white py-24 sm:py-32">
    <Reveal className="mx-auto mb-14 max-w-3xl text-center">
      <Kicker className="mb-5 justify-center">Questions, answered</Kicker>
      <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
        Everything you&apos;re wondering.
      </h2>
    </Reveal>

    <Reveal delay={0.05} className="mx-auto max-w-3xl">
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="border-b border-[#E5E8F0]"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="py-6 text-left font-heading text-lg font-bold tracking-tight text-[#0F1117] transition-colors hover:text-[#2D5BFF] hover:no-underline sm:text-xl [&>svg]:h-5 [&>svg]:w-5 [&>svg]:text-[#2D5BFF]">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-base leading-relaxed text-[#4B5262]">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </Section>
);

export default Faq;
